import { Spin, Typography } from 'antd';
import { FC, ReactNode, memo } from 'react';
import { X } from 'react-bootstrap-icons';

interface BreadcrumbWrapperProps {
  isLoading: boolean;
  isError: boolean;
  data: ReactNode | undefined;
}

export const DynamicBreadcrumbWrapper: FC<BreadcrumbWrapperProps> = memo(({ isLoading, isError, data }) => {
  if (isLoading) {
    return <Spin size="small" style={{ maxHeight: 14, display: 'flex', alignItems: 'center' }}/>;
  }

  if (isError) {
    return (
      <Typography.Text type="danger">
        <X size={ 20 }/>
      </Typography.Text>
    );
  }

  return (
    <Typography.Paragraph
      style={{
        marginBottom: 0,
        maxWidth: 200,
        width: '100%',
        color: 'inherit',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      ellipsis={
        typeof data === 'string' && (data?.length ?? 0) > 20
          ? {
            rows: 1,
            suffix: '',
            tooltip: {
              placement: 'bottom',
              overlayStyle: { minWidth: 'max-content' }
            }
          }
          : undefined
      }
    >
      { data }
    </Typography.Paragraph>
  );
});
